import McFixedTable from './McFixedTable';

export default McFixedTable;
